import { atom } from 'jotai';

export const breakpointsMap = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

export type BreakpointKey = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
export type BreakpointsState = Record<BreakpointKey, boolean>;

const getInitialBreakpoints = (): BreakpointsState => {
  if (typeof window === 'undefined') {
    return {
      xs: false,
      sm: false,
      md: false,
      lg: false,
      xl: false,
      xxl: false,
    };
  }

  const width = document.documentElement.clientWidth || window.innerWidth;
  return {
    xs: width >= breakpointsMap.xs && width < breakpointsMap.sm,
    sm: width >= breakpointsMap.sm && width < breakpointsMap.md,
    md: width >= breakpointsMap.md && width < breakpointsMap.lg,
    lg: width >= breakpointsMap.lg && width < breakpointsMap.xl,
    xl: width >= breakpointsMap.xl && width < breakpointsMap.xxl,
    xxl: width >= breakpointsMap.xxl,
  };
};

export const viewportAtom = atom<BreakpointsState>(getInitialBreakpoints());

viewportAtom.onMount = (setAtom) => {
  const checkUserScreen = () => {
    const width = document.documentElement.clientWidth || window.innerWidth;

    const updatedBreakpoints: BreakpointsState = {
      xs: width >= breakpointsMap.xs && width < breakpointsMap.sm,
      sm: width >= breakpointsMap.sm && width < breakpointsMap.md,
      md: width >= breakpointsMap.md && width < breakpointsMap.lg,
      lg: width >= breakpointsMap.lg && width < breakpointsMap.xl,
      xl: width >= breakpointsMap.xl && width < breakpointsMap.xxl,
      xxl: width >= breakpointsMap.xxl,
    };

    setAtom((prev) => {
      const hasChanged = (
        Object.keys(updatedBreakpoints) as BreakpointKey[]
      ).some((key) => prev[key] !== updatedBreakpoints[key]);

      return hasChanged ? updatedBreakpoints : prev;
    });
  };

  window.addEventListener('resize', checkUserScreen);
  return () => window.removeEventListener('resize', checkUserScreen);
};
